import React, { Component } from 'react';
import PropTypes from 'prop-types';

const styles = {
  root: {
    height: 18,
    width: 18,
    cursor: 'pointer',
  },
  dot: {
    backgroundColor: '#ece9f9',
    height: 8,
    width: 8,
    borderRadius: 999,
    margin: 3,
  },
  active: {
    backgroundColor: '#7B59F7',
  },
};

/**
 * @todo
 * Future improvement work may be possible to increase the quality of this component.
 */
class ProjectionPaginationDot extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.props.onClick(event, this.props.index);
  }

  render() {
    const { active } = this.props;

    let styleDot;
    let classNames;
    if (active) {
      classNames = 'paginationSwipe active';
      styleDot = Object.assign({}, styles.dot, styles.active);
    } else {
      classNames = 'paginationSwipe';
      styleDot = styles.dot;
    }

    return (
      <div
        className={classNames}
        style={styles.root}
        onClick={this.handleClick}
      >
        <div style={styleDot} />
      </div>
    );
  }
}

ProjectionPaginationDot.propTypes = {
  active: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export { ProjectionPaginationDot };
